import { forEach, has, isArray, map, sortBy } from 'lodash';
import { transmitter } from './Transmitter';
import { ANALYST_GOTO_URL, ANALYST_MAP_URL } from '../../constants';

const actions = {

    /**
     * Payload:
     * @param string
     * @param string|object
     * @param string|null
     * @param string|null
     */
    CHANGE_ANSWER (context, [uukey, answer, row, col])
    {
        context.commit('STORE_ANSWER', [uukey, answer, row, col]);
    },

    /**
     * Payload:
     * @param string
     * @param string|object
     * @param string|null
     * @param string|null
     */
    CHANGE_ADD_TO_ANSWER (context, [uukey, value, row, col])
    {
        context.commit('STORE_ADD_TO_ANSWER', [uukey, value, row, col]);
    },

    /**
     * Payload:
     * @param string
     * @param string|object
     * @param string|null
     * @param string|null
     */
    CHANGE_REMOVE_FROM_ANSWER (context, [uukey, value, row, col])
    {
        context.commit('STORE_REMOVE_FROM_ANSWER', [uukey, value, row, col]);
    },

    /**
     * Payload:
     * @param string
     * @param string|object
     * @param string|null
     * @param string|null
     */
    REMOVE_COLUMNS (context, [uukey, cols])
    {
        if (isArray(cols))
        {
            forEach(cols, (col) =>
            {
                context.commit('STORE_REMOVE_COL_FROM_ANSWER', [uukey, col]);
            });
        }
        else
        {
            context.commit('STORE_REMOVE_COL_FROM_ANSWER', [uukey, cols]);
        }
    },

    /**
     * Payload:
     * @param object ex: {"s1":50}
     */
    UPDATE_COMPLETIONS (context, completions)
    {
        forEach(completions, (value, sectionNum) =>
        {
            const num = sectionNum.substr(1);
            context.commit('SET_COMPLETION', [num, value]);
        });
    },

    /**
     *
     */
    NEXT_HELP_COUNTER (context)
    {
        context.commit('INCREMENT_HELP_COUNTER');
    },

    /**
     *
     */
    HIDE_POSTFILL_BUTTON (context)
    {
        context.commit('POSTFILL_BUTTON_TO_HIDDEN');
    },

    //
    ///
    /// // matrix-2d-inclusive-dynamic-rows related :::
    ///
    //

    /**
     *
     */
    CHANGE_2D_INCLUSIVE_DYN_PROP (context, [source, col, newVal, rowID])
    {
        transmitter.submitDynamicRowProp([source, col, newVal, rowID], (response) =>
        {
            if (has(response.data, 'completions'))
            {
                forEach(response.data.completions, (value, sectionNum) =>
                {
                    const num = sectionNum.substr(1);
                    context.commit('SET_COMPLETION', [num, value]);
                });
            }
            if (has(response.data, 'scores'))
            {
                context.commit('UPDATE_DEBUGGER_SCORES', response.data.scores);
            }

            if (has(response.data, 'buildings'))
            {
                context.commit('STORE_2D_INCLUSIVE_DYNAMIC_UPDATE_ALL', [source, response.data.buildings]);
            }
            else if (has(response.data, 'building'))
            {
                context.commit('STORE_2D_INCLUSIVE_DYNAMIC_UPDATE', [source, response.data.building]);
            }
        });
    },

    /**
     *
     */
    CHANGE_2D_INCLUSIVE_DYN_LABEL (context, [source, value, rowID])
    {
        transmitter.submitDynamicRowLabel([source, value, rowID], (response) =>
        {
            if (has(response.data, 'completions'))
            {
                forEach(response.data.completions, (value, sectionNum) =>
                {
                    const num = sectionNum.substr(1);
                    context.commit('SET_COMPLETION', [num, value]);
                });
            }
            if (has(response.data, 'scores'))
            {
                context.commit('UPDATE_DEBUGGER_SCORES', response.data.scores);
            }

            if (has(response.data, 'building'))
            {
                context.commit('STORE_2D_INCLUSIVE_DYNAMIC_UPDATE', [source, response.data.building]);
            }
        });
    },

    /**
     *
     */
    REMOVE_2D_INCLUSIVE_DYN_ROW (context, [source, rowID])
    {
        transmitter.deleteDynamicRow([source, rowID], (response) =>
        {
            if (has(response.data, 'completions'))
            {
                forEach(response.data.completions, (value, sectionNum) =>
                {
                    const num = sectionNum.substr(1);
                    context.commit('SET_COMPLETION', [num, value]);
                });
            }
            if (has(response.data, 'scores'))
            {
                context.commit('UPDATE_DEBUGGER_SCORES', response.data.scores);
            }

            if (has(response.data, 'status') && response.data.status === 'DONE')
            {
                const isIE = !!window.MSInputMethodContext && !!document.documentMode;
                if (isIE)
                {
                    window.location.href = window.location.pathname + '#designe-ctres-srv-temp';
                    window.location.reload();
                }
                else
                {
                    context.commit('DELETE_2D_INCLUSIVE_DYN_ROW', [source, rowID]);
                }
            }

        });
    },

    /**
     *
     */
    ADD_2D_INCLUSIVE_DYN_ROW (context, [source])
    {
        transmitter.addDynamicRow([source], (response) =>
        {
            if (has(response.data, 'completions'))
            {
                forEach(response.data.completions, (value, sectionNum) =>
                {
                    const num = sectionNum.substr(1);
                    context.commit('SET_COMPLETION', [num, value]);
                });
            }
            if (has(response.data, 'scores'))
            {
                context.commit('UPDATE_DEBUGGER_SCORES', response.data.scores);
            }

            if (has(response.data, 'building'))
            {
                context.commit('STORE_2D_INCLUSIVE_DYNAMIC_UPDATE', [source, response.data.building]);
            }
        });
    },

    /**
     *
     */
    WIPE_ALL_2D_INCLUSIVE_DYN_ROW (context, [source])
    {
        transmitter.wipeAllDynamicRow([source], (response) =>
        {
            if (has(response.data, 'completions'))
            {
                forEach(response.data.completions, (value, sectionNum) =>
                {
                    const num = sectionNum.substr(1);
                    context.commit('SET_COMPLETION', [num, value]);
                });
            }
            if (has(response.data, 'scores'))
            {
                context.commit('UPDATE_DEBUGGER_SCORES', response.data.scores);
            }

            if (has(response.data, 'status') && response.data.status === 'DONE')
            {
                context.commit('DELETE_ALL_2D_INCLUSIVE_DYN_ROW', [source]);
            }
        });
    },

    SET_ALL_PROVINCE_CHECKBOX (context, [payload])
    {
        if (!payload)
        {
            context.commit('SET_SELECTED_PROVINCE_REGIONS', ['allProvince', false]);
            transmitter.allProvinceSelection(false);
            transmitter.fetch_from_province((response) =>
            {
                context.commit('SET_REGIONS_LIST', [sortBy(response.data, 'name')]);
            });
        }
        else
        {
            context.commit('SET_REGIONS_LIST', [[]]);
            context.commit('SET_COUNTIES_LIST', [[]]);
            context.commit('SET_SELECTED_PROVINCE_REGIONS', ['allProvince', true]);
            transmitter.allProvinceSelection(true);
            context.commit('SET_SELECTED_PROVINCE_REGIONS', ['regions', []]);
            context.commit('SET_SELECTED_PROVINCE_REGIONS', ['counties', []]);
            transmitter.eraseSelection(['regions', 'counties']);
        }
        // Hide in between arrow:
        if (window.$)
        {
            const $ = window.$
            const $betweenColumns = $('.multiple-select__between-column')
            $betweenColumns.each((idx, elm) =>
            {
                $(elm).toggleClass('hidden', payload === true);
            })
        }
    },

    /**
     *
     */
    SELECT_MULTIPLE_OPTIONS_FOR (context, [source, selectedOptions])
    {
        const codes = map(selectedOptions, 'value');

        switch (source)
        {
        case 'regions':
            context.commit('SET_COUNTIES_LIST', [[]]);
            context.commit('SET_MUNICIPALITIES_LIST', [[]]);
            context.commit('SET_SELECTED_PROVINCE_REGIONS', ['counties', []]);
            transmitter.eraseSelection(['counties', 'municipalities']);
            break;

        case 'counties':
            context.commit('SET_MUNICIPALITIES_LIST', [[]]);
            transmitter.eraseSelection(['municipalities']);
            break;
        }

        context.commit('SET_SELECTED_PROVINCE_REGIONS', [source, codes]);
        transmitter[`fetch_from_${source}`]([codes], (response) =>
        {
            switch (source)
            {
            case 'regions':
                context.commit('SET_COUNTIES_LIST', [sortBy(response.data, 'name')]);
                break;

            case 'counties':
                context.commit('SET_MUNICIPALITIES_LIST', [sortBy(response.data, 'name')]);
                break;
            }
        });

    },

    /**
     *
     */
    GOTO_WITH_SOURCE (context, [source, selectedOptions])
    {
        const codes = map(selectedOptions, 'value').join(',');
        const url = ANALYST_GOTO_URL;
        window.location.href = `${url}/${source}/${codes}`;
    },

    /**
     *
     */
    GOTO_MAP_WITH_SOURCE (context, [source, selectedOption])
    {
        const code = selectedOption.value;
        const url = ANALYST_MAP_URL;
        window.location.href = `${url}/${code}`;
    },

    /**
     * Used within resources/assets/js/components/vue/question-selector.vue
     */
    SET_SELECTED_ANSWERS_FOR_SECTION (context, [sectionNumber, selectedAnswers])
    {
        if (sectionNumber > 0 && sectionNumber < 10)
        {
            context.commit('SET_SELECTED_ANSWERS_FOR_SECTION', [`s${sectionNumber}`, selectedAnswers]);
        }
    },

    /**
     * Used within resources/assets/js/components/vue/question-target-selector.vue
     */
    SET_EXPORT_BUILDINGS (context, [isBuildingPicked])
    {
        context.commit('SET_EXPORT_BUILDINGS', [isBuildingPicked]);
    },
};

export { actions }



// WEBPACK FOOTER //
// ./resources/assets/js/components/vuex/storeActions.js